"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2987],{

/***/ 2987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ FlightRouteDT; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var html_react_parser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7311);
/* harmony import */ var _utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4250);
/* eslint-disable react-hooks/exhaustive-deps */ /* eslint-disable react/no-danger */ 



function FlightRouteDT(props) {
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (language && language === "ar") document.body.classList.add("isArabic");
    });
    var ref = (props === null || props === void 0 ? void 0 : props.data) || {}, language = ref.language, tmp = ref.initial_js, initialJS = tmp === void 0 ? "" : tmp, mainDiv = ref.main_div, top_overlay = ref.top_overlay, ccde = ref.ccde, _isGoibibo = ref.isGoibibo, isGoibibo = _isGoibibo === void 0 ? false : _isGoibibo;
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        (0,_utils_CommonUtils__WEBPACK_IMPORTED_MODULE_3__/* .wireTopAirlineCarousel */ .by)(containerRef.current);
    }, [
        mainDiv
    ]);
    var googleTagId = isGoibibo ? "GTM-5VDCXLQ" : "GTM-NWV3K7C";
    var googletTagString = "(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':\n  new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],\n  j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=\n  'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);\n  })(window,document,'script','dataLayer','".concat(googleTagId, "');\n");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            initialJS && initialJS !== "" ? (0,html_react_parser__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(initialJS) : null,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                ref: containerRef,
                dangerouslySetInnerHTML: {
                    __html: mainDiv
                }
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                dangerouslySetInnerHTML: {
                    __html: top_overlay
                }
            }),
            ccde && (ccde === "" || ccde === "in" || ccde === "IN") ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                dangerouslySetInnerHTML: {
                    __html: googletTagString
                }
            }) : null
        ]
    });
}


/***/ })

}]);